module.exports.run = function(object){
  
  return Object.keys(object).reduce(
    (acc, key) => {
      if(
        object[key] !== undefined
        && object[key] !== null
      ){
        acc[key] = object[key];
      }
      return acc;
    },
    {}
  );
};